// extracted by mini-css-extract-plugin
export default {"button":"ExtensionModification_button__uEcU1","body":"ExtensionModification_body__AmsL6"};